import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import WinGridDark from "../Hero/WinGridDark";

export default function TestimonialsDesktop() {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperOptions = {
    modules: [EffectFade, Pagination, Autoplay, Navigation],
    effect: "fade",
    loop: true,
    autoplay: {
      delay: 5500,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".custom-button-next",
      prevEl: ".custom-button-prev",
    },
    onSlideChange: (swiper) => {
      setActiveIndex(swiper.realIndex);
    }
  };

  const totalSlides = 6; // Updated to match actual number of testimonials

  return (
    <section id="testimonial" className="bg-main-black overflow-hidden">
      <style>
        {`
          .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: rgba(255, 255, 255, 0.5);
            opacity: 1;
            margin: 0 4px !important;
          }
          .swiper-pagination-bullet-active {
            background: #2858b9;
          }
        `}
      </style>
      <div
        className="relative testimoial-section-wrapper justify-center flex w-full xl:py-[130px] pt-[60px] pb-[120px] bg-main-black pointer-events-none"
      >
        <div className="absolute inset-0 pointer-events-auto">
          <WinGridDark />
        </div>
        <div className="relative z-10 mx-auto theme-container pointer-events-none">
          <div className="flex flex-col items-center pointer-events-none">
            <span className="inline-block px-5 py-3 mb-5 font-medium leading-none text-white rounded-full bg-purple">
              What Our Clients Say
            </span>
            <h2 className="md:text-48 text-34 font-semibold text-white mb-[70px] text-center">
              Client Testimonials
            </h2>
          </div>
          <div className="w-full lg:grid grid-cols-12 items-stretch gap-[30px] pointer-events-auto">
            <div className="col-span-4">
              <div className="w-full h-[401px] relative">
                <img
                  src="/assets/images/testimonialImage.jpg"
                  alt=""
                  className="w-full h-full overflow-hidden rounded-[20px] object-top object-cover"
                />
                <div className="absolute left-0 -bottom-5 sm:px-[56px] pl-1 w-full">
                  <div className="flex justify-center p-[7px] bg-yellow shadow-style-one rounded-full items-center">
                    <span className="text-sm font-semibold text-main-black text-nowrap text-center">
                      Real Results, Deep Partnerships
                    </span>
                    {/* <img
                      src="/assets/images/home-one-about-group.webp"
                      alt=""
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="relative h-full col-span-8 mt-20 lg:mt-0">
              <div className="relative w-full h-full">
                <Swiper
                  {...swiperOptions}
                  className="w-full h-full testimonial-swiper"
                >
                  <SwiperSlide>
                    {" "}
                    <div className="w-full bg-purple h-full rounded-[20px] py-10 relative">
                      <div className="absolute left-0 shape top-10">
                        <img
                          src="/assets/images/testimonial-shape.webp"
                          alt=""
                        />
                      </div>
                      <div className="relative z-10">
                        <div className="flex justify-between md:pl-[70px] pl-5 mb-10">
                          <div>
                            <img src="/assets/images/quotation.webp" alt="" />
                          </div>
                          <div className="w-[422px] h-[60px] relative md:flex hidden justify-center">
                            <div className="absolute top-0 left-0 flex w-full h-full">
                              <div className="w-1/2 h-full bg-gradient-to-l from-white opacity-30"></div>
                              <div className="w-1/2 h-full bg-gradient-to-r from-white opacity-30"></div>
                            </div>
                            <div className="flex items-center space-x-5">
                              <span className="font-semibold text-white text-20">
                                Quality Service
                              </span>
                              <div className="flex space-x-[2px] items-center">
                                {[...Array(5)].map((_, i) => (
                                  <svg
                                    key={i}
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.22953 1.14427C7.95375 -0.381422 10.0462 -0.381425 10.7705 1.14427L12.0221 3.78106C12.3097 4.38691 12.8656 4.80684 13.5087 4.904L16.3074 5.32682C17.9268 5.57148 18.5734 7.64059 17.4016 8.82817L15.3764 10.8806C14.9111 11.3522 14.6988 12.0317 14.8086 12.6976L15.2867 15.5957C15.5633 17.2726 13.8704 18.5514 12.422 17.7596L9.91874 16.3913C9.34357 16.0769 8.65643 16.0769 8.08125 16.3913L5.57799 17.7596C4.12955 18.5514 2.43668 17.2726 2.71331 15.5957L3.19139 12.6976C3.30124 12.0317 3.0889 11.3522 2.62357 10.8806L0.598388 8.82818C-0.57342 7.64059 0.0731955 5.57148 1.69259 5.32682L4.49134 4.904C5.1344 4.80684 5.69031 4.38691 5.9779 3.78106L7.22953 1.14427Z"
                                      fill="white"
                                    />
                                  </svg>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="md:px-[70px] px-5">
                          <p className="mb-10 font-semibold text-white text-24 line-clamp-3">
                            "It is a science and art to build high quality Gen AI solutions. The Informulate team is very skilled in AI/LLM development."
                          </p>
                          <div className="flex items-center space-x-5">
                            <div>
                              <p className="font-semibold text-white text-18">
                                Jacques Fu
                              </p>
                              <p className="text-sm font-medium text-white">
                                Co-founder @ Stax, CTO @ Worth.ai
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="w-full bg-purple h-full rounded-[20px] py-10 relative">
                      <div className="absolute left-0 shape top-10">
                        <img
                          src="/assets/images/testimonial-shape.webp"
                          alt=""
                        />
                      </div>
                      <div className="relative z-10">
                        <div className="flex justify-between md:pl-[70px] pl-5 mb-10">
                          <div>
                            <img src="/assets/images/quotation.webp" alt="" />
                          </div>
                          <div className="w-[422px] h-[60px] relative md:flex hidden justify-center">
                            <div className="absolute top-0 left-0 flex w-full h-full">
                              <div className="w-1/2 h-full bg-gradient-to-l from-white opacity-30"></div>
                              <div className="w-1/2 h-full bg-gradient-to-r from-white opacity-30"></div>
                            </div>
                            <div className="flex items-center space-x-5">
                              <span className="font-semibold text-white text-20">
                                Quality Service
                                </span>
                              <div className="flex space-x-[2px] items-center">
                                {[...Array(5)].map((_, i) => (
                                  <svg
                                    key={i}
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.22953 1.14427C7.95375 -0.381422 10.0462 -0.381425 10.7705 1.14427L12.0221 3.78106C12.3097 4.38691 12.8656 4.80684 13.5087 4.904L16.3074 5.32682C17.9268 5.57148 18.5734 7.64059 17.4016 8.82817L15.3764 10.8806C14.9111 11.3522 14.6988 12.0317 14.8086 12.6976L15.2867 15.5957C15.5633 17.2726 13.8704 18.5514 12.422 17.7596L9.91874 16.3913C9.34357 16.0769 8.65643 16.0769 8.08125 16.3913L5.57799 17.7596C4.12955 18.5514 2.43668 17.2726 2.71331 15.5957L3.19139 12.6976C3.30124 12.0317 3.0889 11.3522 2.62357 10.8806L0.598388 8.82818C-0.57342 7.64059 0.0731955 5.57148 1.69259 5.32682L4.49134 4.904C5.1344 4.80684 5.69031 4.38691 5.9779 3.78106L7.22953 1.14427Z"
                                      fill="white"
                                    />
                                  </svg>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="md:px-[70px] px-5">
                          <p className="mb-10 font-semibold text-white text-24 line-clamp-3">
                            "The Informulate team is incredible to work with. They have consistently delivered top-notch solutions, and the ongoing partnership is critical to the success of our program"
                          </p>
                          <div className="flex items-center space-x-5">
                            <div>
                              <p className="font-semibold text-white text-18">
                                Program Manager
                              </p>
                              <p className="text-sm font-medium text-white">
                                Global Top 5 University
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="w-full bg-purple h-full rounded-[20px] py-10 relative">
                      <div className="absolute left-0 shape top-10">
                        <img
                          src="/assets/images/testimonial-shape.webp"
                          alt=""
                        />
                      </div>
                      <div className="relative z-10">
                        <div className="flex justify-between md:pl-[70px] pl-5 mb-10">
                          <div>
                            <img src="/assets/images/quotation.webp" alt="" />
                          </div>
                          <div className="w-[422px] h-[60px] relative md:flex hidden justify-center">
                            <div className="absolute top-0 left-0 flex w-full h-full">
                              <div className="w-1/2 h-full bg-gradient-to-l from-white opacity-30"></div>
                              <div className="w-1/2 h-full bg-gradient-to-r from-white opacity-30"></div>
                            </div>
                            <div className="flex items-center space-x-5">
                              <span className="font-semibold text-white text-20">
                                Quality Service
                                </span>
                              <div className="flex space-x-[2px] items-center">
                                {[...Array(5)].map((_, i) => (
                                  <svg
                                    key={i}
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.22953 1.14427C7.95375 -0.381422 10.0462 -0.381425 10.7705 1.14427L12.0221 3.78106C12.3097 4.38691 12.8656 4.80684 13.5087 4.904L16.3074 5.32682C17.9268 5.57148 18.5734 7.64059 17.4016 8.82817L15.3764 10.8806C14.9111 11.3522 14.6988 12.0317 14.8086 12.6976L15.2867 15.5957C15.5633 17.2726 13.8704 18.5514 12.422 17.7596L9.91874 16.3913C9.34357 16.0769 8.65643 16.0769 8.08125 16.3913L5.57799 17.7596C4.12955 18.5514 2.43668 17.2726 2.71331 15.5957L3.19139 12.6976C3.30124 12.0317 3.0889 11.3522 2.62357 10.8806L0.598388 8.82818C-0.57342 7.64059 0.0731955 5.57148 1.69259 5.32682L4.49134 4.904C5.1344 4.80684 5.69031 4.38691 5.9779 3.78106L7.22953 1.14427Z"
                                      fill="white"
                                    />
                                  </svg>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="md:px-[70px] px-5">
                          <p className="mb-10 font-semibold text-white text-24 line-clamp-3">
                            "They have been invaluable, especially as they both put in the time to learn about our strategy and often complex business processes"
                          </p>
                          <div className="flex items-center space-x-5">
                            <div>
                              <p className="font-semibold text-white text-18">
                                Josh Layne
                              </p>
                              <p className="text-sm font-medium text-white">
                                VP @ Maple Street
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="w-full bg-purple h-full rounded-[20px] py-10 relative">
                      <div className="absolute left-0 shape top-10">
                        <img
                          src="/assets/images/testimonial-shape.webp"
                          alt=""
                        />
                      </div>
                      <div className="relative z-10">
                        <div className="flex justify-between md:pl-[70px] pl-5 mb-10">
                          <div>
                            <img src="/assets/images/quotation.webp" alt="" />
                          </div>
                          <div className="w-[422px] h-[60px] relative md:flex hidden justify-center">
                            <div className="absolute top-0 left-0 flex w-full h-full">
                              <div className="w-1/2 h-full bg-gradient-to-l from-white opacity-30"></div>
                              <div className="w-1/2 h-full bg-gradient-to-r from-white opacity-30"></div>
                            </div>
                            <div className="flex items-center space-x-5">
                              <span className="font-semibold text-white text-20">
                                Quality Service
                              </span>
                              <div className="flex space-x-[2px] items-center">
                                {[...Array(5)].map((_, i) => (
                                  <svg
                                    key={i}
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.22953 1.14427C7.95375 -0.381422 10.0462 -0.381425 10.7705 1.14427L12.0221 3.78106C12.3097 4.38691 12.8656 4.80684 13.5087 4.904L16.3074 5.32682C17.9268 5.57148 18.5734 7.64059 17.4016 8.82817L15.3764 10.8806C14.9111 11.3522 14.6988 12.0317 14.8086 12.6976L15.2867 15.5957C15.5633 17.2726 13.8704 18.5514 12.422 17.7596L9.91874 16.3913C9.34357 16.0769 8.65643 16.0769 8.08125 16.3913L5.57799 17.7596C4.12955 18.5514 2.43668 17.2726 2.71331 15.5957L3.19139 12.6976C3.30124 12.0317 3.0889 11.3522 2.62357 10.8806L0.598388 8.82818C-0.57342 7.64059 0.0731955 5.57148 1.69259 5.32682L4.49134 4.904C5.1344 4.80684 5.69031 4.38691 5.9779 3.78106L7.22953 1.14427Z"
                                      fill="white"
                                    />
                                  </svg>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="md:px-[70px] px-5">
                          <p className="mb-10 font-semibold text-white text-24 line-clamp-3">
                            "AI is transforming the way in which companies operate, and businesses require strong partners to support their success. The team at Informulate is outstanding at developing AI technologies to help you succeed."
                          </p>
                          <div className="flex items-center space-x-5">
                            <div>
                              <p className="font-semibold text-white text-18">
                                Pete McAlindon
                              </p>
                              <p className="text-sm font-medium text-white">
                                CEO @ BlueOrb, Entrepreneur-in-Residence @ Crummer Graduate School
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="w-full bg-purple h-full rounded-[20px] py-10 relative">
                      <div className="absolute left-0 shape top-10">
                        <img
                          src="/assets/images/testimonial-shape.webp"
                          alt=""
                        />
                      </div>
                      <div className="relative z-10">
                        <div className="flex justify-between md:pl-[70px] pl-5 mb-10">
                          <div>
                            <img src="/assets/images/quotation.webp" alt="" />
                          </div>
                          <div className="w-[422px] h-[60px] relative md:flex hidden justify-center">
                            <div className="absolute top-0 left-0 flex w-full h-full">
                              <div className="w-1/2 h-full bg-gradient-to-l from-white opacity-30"></div>
                              <div className="w-1/2 h-full bg-gradient-to-r from-white opacity-30"></div>
                            </div>
                            <div className="flex items-center space-x-5">
                              <span className="font-semibold text-white text-20">
                                Quality Service
                                </span>
                              <div className="flex space-x-[2px] items-center">
                                {[...Array(5)].map((_, i) => (
                                  <svg
                                    key={i}
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.22953 1.14427C7.95375 -0.381422 10.0462 -0.381425 10.7705 1.14427L12.0221 3.78106C12.3097 4.38691 12.8656 4.80684 13.5087 4.904L16.3074 5.32682C17.9268 5.57148 18.5734 7.64059 17.4016 8.82817L15.3764 10.8806C14.9111 11.3522 14.6988 12.0317 14.8086 12.6976L15.2867 15.5957C15.5633 17.2726 13.8704 18.5514 12.422 17.7596L9.91874 16.3913C9.34357 16.0769 8.65643 16.0769 8.08125 16.3913L5.57799 17.7596C4.12955 18.5514 2.43668 17.2726 2.71331 15.5957L3.19139 12.6976C3.30124 12.0317 3.0889 11.3522 2.62357 10.8806L0.598388 8.82818C-0.57342 7.64059 0.0731955 5.57148 1.69259 5.32682L4.49134 4.904C5.1344 4.80684 5.69031 4.38691 5.9779 3.78106L7.22953 1.14427Z"
                                      fill="white"
                                    />
                                  </svg>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="md:px-[70px] px-5">
                          <p className="mb-10 font-semibold text-white text-24 line-clamp-3">
                            "Informulate ramped up quickly on the scope of work, our technology, and the business case. They were able to design the right solution and delivered it with high quality and on budget. I'd highly recommend their expertise."
                          </p>
                          <div className="flex items-center space-x-5">
                            <div>
                              <p className="font-semibold text-white text-18">
                                Adam Scheinberg
                              </p>
                              <p className="text-sm font-medium text-white">
                                VP @ Massey Services
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="w-full bg-purple h-full rounded-[20px] py-10 relative">
                      <div className="absolute left-0 shape top-10">
                        <img
                          src="/assets/images/testimonial-shape.webp"
                          alt=""
                        />
                      </div>
                      <div className="relative z-10">
                        <div className="flex justify-between md:pl-[70px] pl-5 mb-10">
                          <div>
                            <img src="/assets/images/quotation.webp" alt="" />
                          </div>
                          <div className="w-[422px] h-[60px] relative md:flex hidden justify-center">
                            <div className="absolute top-0 left-0 flex w-full h-full">
                              <div className="w-1/2 h-full bg-gradient-to-l from-white opacity-30"></div>
                              <div className="w-1/2 h-full bg-gradient-to-r from-white opacity-30"></div>
                            </div>
                            <div className="flex items-center space-x-5">
                              <span className="font-semibold text-white text-20">
                                Quality Service
                                </span>
                              <div className="flex space-x-[2px] items-center">
                                {[...Array(5)].map((_, i) => (
                                  <svg
                                    key={i}
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.22953 1.14427C7.95375 -0.381422 10.0462 -0.381425 10.7705 1.14427L12.0221 3.78106C12.3097 4.38691 12.8656 4.80684 13.5087 4.904L16.3074 5.32682C17.9268 5.57148 18.5734 7.64059 17.4016 8.82817L15.3764 10.8806C14.9111 11.3522 14.6988 12.0317 14.8086 12.6976L15.2867 15.5957C15.5633 17.2726 13.8704 18.5514 12.422 17.7596L9.91874 16.3913C9.34357 16.0769 8.65643 16.0769 8.08125 16.3913L5.57799 17.7596C4.12955 18.5514 2.43668 17.2726 2.71331 15.5957L3.19139 12.6976C3.30124 12.0317 3.0889 11.3522 2.62357 10.8806L0.598388 8.82818C-0.57342 7.64059 0.0731955 5.57148 1.69259 5.32682L4.49134 4.904C5.1344 4.80684 5.69031 4.38691 5.9779 3.78106L7.22953 1.14427Z"
                                      fill="white"
                                    />
                                  </svg>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="md:px-[70px] px-5">
                          <p className="mb-10 font-semibold text-white text-24 line-clamp-3">
                            "Over the past 4 years, the Informulate team has gained my organization's trust. Having an expert outside opinion has been successful to plan and strategize in today's fast-paced digital world"
                          </p>
                          <div className="flex items-center space-x-5">
                            <div>
                              <p className="font-semibold text-white text-18">
                                Sarah Sefcik
                              </p>
                              <p className="text-sm font-medium text-white">
                                CTO @ Employment Technologies
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className="flex items-center justify-center mt-8 space-x-4">
                        <button
                          type="button"
                    className="custom-button-prev w-[30px] h-[30px] rounded-full flex justify-center items-center bg-purple focus:bg-blue-sass"
                        >
                          <span>
                            <svg
                              width="12"
                              height="10"
                              viewBox="0 0 12 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.75 9L1 5.25M1 5.25L4.75 1.5M1 5.25L11 5.25"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </button>
                  <div className="flex items-center space-x-2">
                    {[...Array(totalSlides)].map((_, index) => (
                      <div
                        key={index}
                        className={`w-2 h-2 rounded-full transition-colors duration-300 ${index === activeIndex
                          ? 'bg-[#2858b9]'
                          : 'bg-white/50'
                          }`}
                      />
                    ))}
                      </div>
                        <button
                          type="button"
                    className="custom-button-next w-[30px] h-[30px] rounded-full flex justify-center items-center bg-purple focus:bg-blue-sass"
                        >
                          <span>
                            <svg
                              width="12"
                              height="10"
                              viewBox="0 0 12 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.25 9L11 5.25M11 5.25L7.25 1.5M11 5.25L1 5.25"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
